export default "__VITE_ASSET__D5V9_Hiw__"